import { gql } from '@apollo/client';

import { DateRange, MedicalRecordsExport } from './MedicalRecords.types';

export const GENERATE_MEDICAL_RECORDS_EXPORT = gql`
  mutation generateMedicalRecordsExport($dateRange: MedicalRecordsExportDateRangeEnum!) {
    generateMedicalRecordsExport(dateRange: $dateRange) {
      medicalRecordsExport {
        id
        status
        downloadUrl
      }
    }
  }
`;

export interface GenerateMedicalRecordsExportResponse {
  generateMedicalRecordsExport: {
    medicalRecordsExport: MedicalRecordsExport;
  };
}

export interface GenerateMedicalRecordsExportVariables {
  dateRange: DateRange;
}

export const MEDICAL_RECORDS_EXPORT = gql`
  query medicalRecordsExport($id: ID!) {
    medicalRecordsExport(id: $id) {
      id
      status
      downloadUrl
    }
  }
`;

export interface MedicalRecordsExportResponse {
  medicalRecordsExport: MedicalRecordsExport | null;
}

export interface MedicalRecordsExportVariables {
  id: string;
}
